import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import useMapPreference from '../useMapPreference';
import './ArenaLink.css';

export default function ArenaLink({ venue }) {
    const dialog = useRef(null);
    const preference = useMapPreference();
    const query = encodeURIComponent(String(venue).trim());
    const appleDevice = /iPhone|iPad|iPod|Mac/.test(navigator.platform || navigator.userAgent);
    const urls = {google: `https://www.google.com/maps/search/?api=1&query=${query}`, apple: `https://maps.apple.com/?q=${query}`};
    const selected = !appleDevice ? 'google' : preference.provider;
    const open = () => dialog.current.showModal();
    const choose = provider => {
        dialog.current.close();
        preference.save(provider);
    };
    const label = <>⌖ <span>{venue}</span> ↗</>;
    return <>
        <span className="arena-controls">
            {preference.ready && selected !== 'ask' ? <a className="arena-link" href={urls[selected]} target="_blank" rel="noopener noreferrer" aria-label={`Visa ${venue} i ${selected === 'apple' ? 'Apple Maps' : 'Google Maps'}`}>{label}</a> : <button type="button" disabled={!preference.ready} className="arena-link" aria-haspopup="dialog" aria-label={`Visa ${venue} på karta`} onClick={open}>{label}</button>}
        </span>
        {createPortal(<dialog ref={dialog} className="arena-dialog" aria-label="Visa arenan på karta" onClick={event => { if (event.target === event.currentTarget) dialog.current.close(); }}>
            <div className="arena-dialog-content">
                <div className="arena-dialog-heading"><h2>Visa på karta</h2><button type="button" aria-label="Stäng kartval" onClick={() => dialog.current.close()}>×</button></div>
                <p>{venue}</p>
                <a href={urls.google} onClick={() => choose('google')} target="_blank" rel="noopener noreferrer">Google Maps <span aria-hidden="true">↗</span></a>
                {appleDevice && <a href={urls.apple} onClick={() => choose('apple')} target="_blank" rel="noopener noreferrer">Apple Maps <span aria-hidden="true">↗</span></a>}
                <small className="arena-remember">Ditt val sparas.</small>
                <p className="arena-notice" role="status">{preference.notice}</p>
            </div>
        </dialog>, document.body)}
    </>;
}
